import { render, staticRenderFns } from "./QuestionPopup.vue?vue&type=template&id=62274fe8&scoped=true&"
import script from "./QuestionPopup.vue?vue&type=script&lang=js&"
export * from "./QuestionPopup.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPopup.vue?vue&type=style&index=0&id=62274fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62274fe8",
  null
  
)

export default component.exports